import './index.scss';

import '@splidejs/splide/css/core';

import Splide from '@splidejs/splide';

class SliderGallery {
    constructor(root) {
        this.root = root;
        this.navLocked = false;
        this.navUnlockTimer = null;

        const splideThumbs = this.root.querySelector('.splide--thumbs');
        if (splideThumbs) {
            this.splideThumbs = new Splide(splideThumbs, {
                type: 'loop',
                arrows: false,
                pagination: false,
                isNavigation: true,
                perPage: 5,
                gap: 8,
                mediaQuery: 'min',
                breakpoints: {
                    768: { gap: 16 },
                    1280: { gap: 24 },
                }
            });
        }

        const splideImages = this.root.querySelector('.splide--images');
        if (splideImages) {
            this.splideImages = new Splide(splideImages, {
                type: 'fade',
                rewind: true,
            });
        }

        if (!this.splideImages) {
            return;
        }

        if (this.splideThumbs) {
            this.splideImages.sync(this.splideThumbs);
        }

        this.splideImages.mount();

        if (this.splideThumbs) {
            this.splideThumbs.mount();
        }

        // Main arrows only (thumbs use arrows: false).
        this.buttonPrev = splideImages.querySelector('.splide__arrow--prev');
        this.buttonNext = splideImages.querySelector('.splide__arrow--next');

        this.bindArrow(this.buttonPrev);
        this.bindArrow(this.buttonNext);

        this.splideImages.on('moved resized updated refreshed', () => {
            this.clearNavUnlockTimer();
            this.navLocked = false;
        });

        // Splide toggles disabled at ends; blur so focus does not linger on a hidden control.
        this.splideImages.on('arrows:updated', (prev, next) => {
            this.blurIfDisabled(prev);
            this.blurIfDisabled(next);
        });
    }

    bindArrow(button) {
        if (!button) {
            return;
        }

        // Capture phase: gate rapid double click/tap before Splide's own handler.
        button.addEventListener('click', (event) => {
            this.onArrowClick(event);
        }, true);
        button.addEventListener('dblclick', (event) => {
            event.preventDefault();
        });
    }

    onArrowClick(event) {
        if (this.navLocked || this.splideImages.Components.Controller.isBusy()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
        }

        this.navLocked = true;
        this.clearNavUnlockTimer();
        this.navUnlockTimer = window.setTimeout(() => {
            this.navUnlockTimer = null;
            this.navLocked = false;
        }, 450);
    }

    clearNavUnlockTimer() {
        if (this.navUnlockTimer !== null) {
            window.clearTimeout(this.navUnlockTimer);
            this.navUnlockTimer = null;
        }
    }

    blurIfDisabled(button) {
        if (button && button.disabled && document.activeElement === button) {
            button.blur();
        }
    }
}

window.app.run(() => {
    document.querySelectorAll('.slidergallery').forEach((node) => {
        new SliderGallery(node);
    });
});
